import { render, staticRenderFns } from "./TagDiferenciaNav.vue?vue&type=template&id=80085032&functional=true&"
import script from "./TagDiferenciaNav.vue?vue&type=script&lang=js&"
export * from "./TagDiferenciaNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports